import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Clock, Instagram, ArrowRight } from 'lucide-react'

export default function ArtistOnboardingSuccessPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-6">
        {/* Waiting Icon */}
        <div className="text-center">
          <div className="mx-auto w-20 h-20 bg-blue-500 rounded-full flex items-center justify-center mb-6">
            <Clock className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-blue-700 mb-2">Profile Submitted!</h1>
          <p className="text-muted-foreground">
            Thank you! We're doing our final review and will contact you on Instagram once your profile is live.
          </p>
        </div>

        {/* Review Process Card */}
        <Card className="border-blue-200 bg-blue-50">
          <CardHeader>
            <CardTitle className="text-blue-800">What happens next?</CardTitle>
            <CardDescription className="text-blue-700">
              We're reviewing your profile and will be in touch soon
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4 text-blue-800">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-white text-xs font-bold">1</span>
              </div>
              <div>
                <p className="font-medium">Final Review</p>
                <p className="text-sm text-blue-700">Our team is doing a final quality check on your profile</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Instagram className="w-3 h-3 text-white" />
              </div>
              <div>
                <p className="font-medium">Instagram Notification</p>
                <p className="text-sm text-blue-700">We'll message you on Instagram when your profile goes live</p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-white text-xs font-bold">3</span>
              </div>
              <div>
                <p className="font-medium">Start Earning</p>
                <p className="text-sm text-blue-700">Once live, clients can book your tattoos and flashes</p>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button 
            variant="outline" 
            className="w-full flex items-center justify-center gap-2"
            onClick={() => window.location.href = '/'}
          >
            Explore GetMoreTats
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>

        {/* Contact Info */}
        <div className="text-center text-sm text-muted-foreground">
          <p>
            Questions? Contact us at{' '}
            <a href="mailto:support@getmoretats.com" className="text-primary hover:underline">
              support@getmoretats.com
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
